import dataStore from '../../../../data/data';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

class Body {
  constructor(id, target) {
    this.id = id;
    this.target = target;
  }

  async run() {
    const date = dataStore.getState().mirror.currentDate;

    const url =
      `${process.env.REACT_APP_PHI_WEB_URL}/mirror-cast-download` +
      `?id=${this.id}` +
      `&date=${date}` +
      `&env=${process.env.REACT_APP_STAGING}` +
      `&type=mesh`;

    const resp = await fetch(url);

    if (!resp.ok) {
      throw new Error(`API failed: ${resp.status}`);
    }

    const wrapper = await resp.json();
    const signedUrl = wrapper.url;
    const loader = new GLTFLoader();

    const gltf = await new Promise((resolve, reject) => {
      loader.load(
        signedUrl,
        resolve,
        undefined,
        reject
      );
    });

    const body = gltf.scene;

    dataStore.setState((_data) => ({
      ..._data,
      mediaprocessing: {
        ..._data.mediaprocessing,
        [this.target]: {
          ..._data.mediaprocessing[this.target],
          body: body,
        },
      },
    }));

    return body;
  }
}

export default Body;